<template>
  <div class="progress-wrapper">
    <div class="progress-container">
      <div class="progress-bar" :style="{ width: value + '%' }"></div>
    </div>
  </div>
</template>
<script>
export default {
  name: "progress-widget",
  props: {
    value: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
$assets: "~@/assets";
.progress-wrapper {
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  .progress-container {
    background: #ebeff2;
    border-radius: 3px;
    height: 5px;
    width: 100%;
    display: flex;
    .progress-bar {
      height: 100%;
      width: 40%;
      border-radius: 3px;
      transition: 400ms ease-in-out;
    }
  }
  &.p-danger {
    .progress-container {
      background: #ebeff2;
      .progress-bar {
        background: #dd5959;
      }
    }
  }
  &.p-warning {
    .progress-container {
      background: #ebeff2;
      .progress-bar {
        background: #ffc273;
      }
    }
  }
  &.p-success {
    .progress-container {
      background: #ebeff2;
      .progress-bar {
        background: #1ba5a4;
      }
    }
  }
}
</style>